import { checkAuth } from './checkauth';


export const headers = (auth)=>({ Authorization: `Osvita ${auth.token}`, 'Content-type': "application/json" });